import type { Prototype } from "../prototype-types";

export const andrewLiuPrototypes: Prototype[] = [
  {
    id: "ai-bulk-editor",
    name: "AI-Enhanced Bulk Editor",
    path: "/al/ai-bulk-editor",
    description:
      "POS integration bulk editor with AI-prefilled product fields (type, tags, descriptions). Demonstrates inline suggestions, sparkle icons, and rewrite panel.",
    owner: "Andrew Liu",
    createdAt: "2026-03-05",
    lastUpdated: "2026-03-05",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6322751c3b8a0db47c691da6fa126ea432231aa277d7bd18fd39a2540618fbe6.png",
    creationTool: "cursor",
  },
];
